import type { SeatQuantityChangeResult } from "@/domain/model/AccountBilling";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";
import type { IdempotencyKeyFactory } from "@/domain/port/IdempotencyKeyFactory";

export class IncreaseAccountSeats {
  constructor(
    private readonly service: AccountManagementService,
    private readonly idempotencyKeyFactory: IdempotencyKeyFactory,
  ) {}

  execute(
    targetSeatQuantity: number,
    signal?: AbortSignal,
  ): Promise<SeatQuantityChangeResult> {
    return this.service.increaseSeats(
      targetSeatQuantity,
      this.idempotencyKeyFactory.create(),
      signal,
    );
  }
}
